import React from 'react';
import { Container, SectionHeader, Reveal } from './landing/primitives';

const useCases = [
  { id: 'founders', label: 'Founders', title: 'Ship faster with AI-powered workflows', desc: 'Automate the repetitive, prototype in hours and move from idea to product-market fit with a co-pilot that keeps up.', metric: ['10x', 'faster prototyping'] },
  { id: 'teams', label: 'Teams', title: 'Collaborate in shared AI workspaces', desc: 'Shared sessions, team knowledge bases and workflows that keep distributed teams aligned.', metric: ['3x', 'team productivity'] },
  { id: 'enterprises', label: 'Enterprises', title: 'Deploy AI across the organization', desc: 'Enterprise-grade security, compliance and custom deployments — from support automation to knowledge management.', metric: ['99.99%', 'uptime SLA'] },
  { id: 'developers', label: 'Developers', title: 'Build on flexible, familiar APIs', desc: 'OpenAI-compatible endpoints, streaming, function calling and SDKs for the tools you already use.', metric: ['<50ms', 'API latency'] },
  { id: 'marketers', label: 'Marketers', title: 'Create, analyze and optimize at scale', desc: 'Generate campaigns, analyze performance and personalize content with AI that understands your brand voice.', metric: ['5x', 'content output'] },
  { id: 'researchers', label: 'Researchers', title: 'Accelerate discovery and analysis', desc: 'Process papers, analyze datasets and explore knowledge graphs with an assistant fluent in your domain.', metric: ['8x', 'review speed'] },
];

const UseCases = () => (
  <section className="py-24 lg:py-32 border-t border-line" data-testid="usecases-section">
    <Container>
      <SectionHeader
        eyebrow="Use cases"
        title="Built for everyone who builds."
        subtitle="From solo founders to research labs — one platform, tuned to how each team actually works."
      />
      <Reveal delay={0.1} className="mt-16 lg:mt-20 grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-line border border-line">
        {useCases.map((uc) => (
          <div key={uc.id} className="group bg-app p-8 lg:p-10 flex flex-col hover:bg-surface-2 transition-colors duration-300" data-testid={`usecase-item-${uc.id}`}>
            <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-content-3">{uc.label}</p>
            <h3 className="mt-6 text-xl font-heading font-medium tracking-tight text-content leading-snug">{uc.title}</h3>
            <p className="mt-3 text-content-2 text-sm leading-relaxed">{uc.desc}</p>
            <p className="mt-auto pt-10 flex items-baseline gap-2">
              <span className="text-2xl font-heading font-medium tracking-tight text-content tabular-nums">{uc.metric[0]}</span>
              <span className="text-xs text-content-3">{uc.metric[1]}</span>
            </p>
          </div>
        ))}
      </Reveal>
    </Container>
  </section>
);

export default UseCases;
